import React from "react";
import Product from "../../features/adminDashboard/products/Product";

function ProductPage() {
  return <Product />;
}

export default ProductPage;
